import { FormState } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { CurrencyInput } from 'ui'
import { MaxPriceKeys } from '../../../../../../../typings'
import messages from './messages'

interface Props {
  state: FormState
}

export function MaxPriceSettings(props: Props) {
  const { state: form } = props

  const { $t } = useIntl()

  const label = $t(messages.currencyInput.helpText)

  return (
    <CurrencyInput
      name={MaxPriceKeys.price}
      aria-label={label}
      state={form}
      helpText={label}
    />
  )
}
